import axios from 'axios'
import router from '@/router.js'
import session from '@/api/session.js'

class Api {
  constructor() {
    this.api = this.intializeAxios();

    return this.api;
  }

  intializeAxios() {
    const api = axios.create({
      baseURL: process.env.VUE_APP_APIURL + '/v1/',
      timeout: 30000,
      validateStatus(status) {
        // send user to signin page if unauthorized
        if (status === 401) {
          session.clear();
          router.push({ name: 'signin' });
        }

        return status >= 200 && status < 300;
      }
    });

    api.interceptors.request.use(function (config) {
      const token = session.getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    });

    return api;
  }
}

const api = new Api();

export default api;
